import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { PostingProfilesService } from 'src/app/features/posting-profile/services/postingProfiles-api-service';
import { UserService } from 'src/app/shared/services/user-service';
import { CustuomtoastserviceService } from 'src/app/shared/services/custuomtoastservice.service';
import { BaseUserModel } from 'src/app/Models/userModel';
import {
  CreateIMSproductRequest,
  ProductActionModel,
  ProductAttributeModel,
  ProductImageModel,
  IMSproductResponse,
  ProductPostingProfileRuleMappingModel,
  ProductInternalStatus,
  ProductSupplyType,
  ProductStatus,
  ProductListingStatus,
  ProductAttribute,
  ProductCategoryType,
  ProductCategoryTypeAttribute,
} from '../../../models/product.model';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { firstValueFrom, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule, ViewportScroller } from '@angular/common';
import {
  NamedResponse,
  SharedBrandsResponse,
  SharedCarriersResponse,
  SharedProductCategoriesResponse,
  SharedProductDepartmentsResponse,
  SharedSuppliersResponse,
} from 'src/app/shared/models/shared.model';
import { SharedService } from 'src/app/shared/services/shared-api.service';
import { ProductService } from '../../../services/product-api.service';
import { MarketplaceAccountLiteResponse } from 'src/app/Models/marketplaceAccountModel';
import { PostingProfileResponse } from 'src/app/features/posting-profile/models/strategiesModel';

@Component({
  selector: 'app-add-update-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-update-product.component.html',
  styleUrl: './add-update-product.component.css',
})
export class AddUpdateProductComponent {
  @ViewChild('tab1Scroller') tab1Scroller!: ElementRef<HTMLDivElement>;
  isLoading: boolean = false;

  //parent component communication
  @Output() triggerParentMethod = new EventEmitter();

  //Shared List
  departmentsList: SharedProductDepartmentsResponse[] = [];
  categoriesList: SharedProductCategoriesResponse[] = [];
  suppliersList: SharedSuppliersResponse[] = [];
  brandsList: SharedBrandsResponse[] = [];
  // unitsList: SharedUnitsResponse[] = [];
  carriersList: SharedCarriersResponse[] = [];

  //product required Enum List
  productStatusEnumList: NamedResponse[] = [];
  productTypeEnumList: NamedResponse[] = [];
  conditionEnumList: NamedResponse[] = [];
  internalStausEnumList: NamedResponse[] = [];
  discriminatorEnumList: NamedResponse[] = [];
  trackInventoryOptionEnumList: NamedResponse[] = [];
  listingStatusEnumList: NamedResponse[] = [];
  supplyTypeEnumList: NamedResponse[] = [];
  marketplaceEnumList: NamedResponse[] = [];
  postingProfileEnumList: NamedResponse[] = [];
  auctionStartOptionEnumList: NamedResponse[] = [];
  postingProfileRuleTypeEnumList: NamedResponse[] = [];
  endOfAuctionActionEnumList: NamedResponse[] = [];
  dimensionUnitEnumList: NamedResponse[] = [];
  weightUnitEnumList: NamedResponse[] = [];

  //Data List
  shipmentBoxesList: NamedResponse[] = [];
  warehouseLocationList: NamedResponse[] = [];
  postingProfileList: PostingProfileResponse[] = [];
  filteredPostingProfiles: PostingProfileResponse[] = [];
  userDetails: BaseUserModel = new BaseUserModel();

  //Search
  searchWarehouseLocation: string = '';

  //utential
  defaultWarehouseId: number = 0;
  createUpdateAction: ProductActionModel = new ProductActionModel();
  isActionLoading: boolean = false;
  createProductRequest: CreateIMSproductRequest = new CreateIMSproductRequest();
  productSupplyType = ProductSupplyType;

  //posting profile rules
  postingProfile: PostingProfileResponse = new PostingProfileResponse();
  postingProfileRuleMappingList: ProductPostingProfileRuleMappingModel[] = [];

  //attribute management
  createAttributeName: string = '';
  productAttributes: ProductAttribute[] = [];
  selectedAttributes: { [attributeName: string]: string | number | null } = {};
  categoryType: ProductCategoryType = new ProductCategoryType();

  //steps
  tabIndex = 1;
  stepsFeildArray: NamedResponse[] = [
    { id: 1, name: 'General Information' },
    { id: 2, name: 'Assign posting profile' },
    { id: 3, name: 'Physical attributes' },
    { id: 4, name: 'Add Images' },
    { id: 5, name: 'Review' },
  ];

  //image variables
  productsImagesToReview: ProductImageModel[] = [];
  productImagesToDelete: ProductImageModel[] = [];
  primaryImageId: number = 0;
  @ViewChild('browseProductImgEle')
  browseProductImgEle!: ElementRef<HTMLElement>;
  maxImages: number = 9; // Maximum number of images allowed
  searchPostingProfileText: string = '';

  ngOnInit() {
    let userObj = this.userService.getUserFromLocalStorage();
    if (userObj) this.userDetails = userObj;
    this.defaultWarehouseId = Number(localStorage.getItem('warehouseId'));
  }

  constructor(
    private postingProfileService: PostingProfilesService,
    private userService: UserService,
    private toaster: CustuomtoastserviceService,
    private productService: ProductService,
    private sharedService: SharedService,
    private errorService: ErrorHandlerService,
    private viewportScroller: ViewportScroller
  ) {}

  async loadRequiredData(): Promise<void> {
    await Promise.all([
      this.loadLookupsAsync(),
      this.getDepartmentsListAsync(),
      this.getBrandsListAsync(),
      this.getSuppliersListAsync(),
      this.getWarehouseLocationsListAsync(),
      this.getCarriersListAsync(),
      this.getShipmentBoxesAsync(),
      this.getPostingProfilesList(),
    ]);
  }

  // ===============================================================Get Code ================================================================
  async loadLookupsAsync(): Promise<void> {
    try {
      const storageKey = 'lookups';
      const storedData = await localStorage.getItem(storageKey);
      if (!storedData) return;

      const dataArray = await JSON.parse(storedData);
      if (!Array.isArray(dataArray)) return;
      this.productStatusEnumList = this.getLookupItems(
        dataArray,
        'ProductStatus'
      );
      this.conditionEnumList = this.getLookupItems(
        dataArray,
        'ProductCondition'
      );
      this.productTypeEnumList = this.getLookupItems(dataArray, 'ProductType');
      this.internalStausEnumList = this.getLookupItems(
        dataArray,
        'ProductInternalStatus'
      );
      this.listingStatusEnumList = this.getLookupItems(
        dataArray,
        'ProductListingStatus'
      );
      this.discriminatorEnumList = this.getLookupItems(
        dataArray,
        'ProductDiscriminator'
      );
      this.trackInventoryOptionEnumList = this.getLookupItems(
        dataArray,
        'TrackInventoryOption'
      );
      this.supplyTypeEnumList = this.getLookupItems(
        dataArray,
        'ProductSupplyType'
      );
      this.marketplaceEnumList = this.getLookupItems(dataArray, 'Marketplace');
      this.auctionStartOptionEnumList = this.getLookupItems(
        dataArray,
        'AuctionStartOption'
      );
      this.postingProfileRuleTypeEnumList = this.getLookupItems(
        dataArray,
        'PostingProfileRuleType'
      );
      this.endOfAuctionActionEnumList = this.getLookupItems(
        dataArray,
        'EndOfAuctionAction'
      );
      this.postingProfileEnumList = this.getLookupItems(dataArray, 'Status');
      this.dimensionUnitEnumList = this.getLookupItems(
        dataArray,
        'DimensionUnits'
      );
      this.weightUnitEnumList = this.getLookupItems(dataArray, 'WeightUnits');
    } catch (error) {
      console.error('Failed to load lookups:', error);
    }
  }

  scrollToTopTab1() {
    setTimeout(() => {
      this.tab1Scroller?.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }

  private getLookupItems(data: any[], key: string): any[] {
    return data.find((item) => item.name === key)?.items || [];
  }

  async getDepartmentsListAsync(): Promise<void> {
    this.sharedService
      .getSharedDepartments(this.userDetails.companyId)
      .subscribe({
        next: (data: SharedProductDepartmentsResponse[]) => {
          this.departmentsList = data;
        },
        error: (error: Error) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getBrandsListAsync(): Promise<void> {
    this.sharedService.getSharedBrands(this.userDetails.companyId).subscribe({
      next: (data: SharedBrandsResponse[]) => {
        this.brandsList = data;
      },
      error: (error: Error) => {
        this.errorService.handleError(error);
      },
    });
  }

  async getCategoriesListAsync(): Promise<void> {
    const departmentId = this.createProductRequest.productDepartmentId;
    this.createProductRequest.categoryId = null; // Reset categoryId when department changes
    this.categoriesList = [];

    if (departmentId === null || departmentId === 0) {
      return;
    }
    this.sharedService
      .getSharedCategories(this.userDetails.companyId, departmentId)
      .subscribe({
        next: (data: SharedProductCategoriesResponse[]) => {
          this.categoriesList = data;
        },
        error: (error: Error) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getSuppliersListAsync(): Promise<void> {
    this.sharedService
      .getSharedSuppliers(this.userDetails.companyId)
      .subscribe({
        next: (data: SharedSuppliersResponse[]) => {
          this.suppliersList = data;
        },
        error: (error: Error) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getCarriersListAsync(): Promise<void> {
    this.sharedService.getSharedCarriers(this.userDetails.companyId).subscribe({
      next: (data: SharedCarriersResponse[]) => {
        this.carriersList = data;
      },
      error: (error: Error) => {
        this.errorService.handleError(error);
      },
    });
  }

  async getWarehouseLocationsListAsync(): Promise<void> {
    this.sharedService
      .getWarehouseLocations(
        this.userDetails.companyId,
        this.defaultWarehouseId,
        true
      )
      .subscribe({
        next: (data: NamedResponse[]) => {
          this.warehouseLocationList = data;
        },
        error: (error: Error) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getShipmentBoxesAsync(): Promise<void> {
    this.sharedService.getShipmentBoxes(this.userDetails.companyId).subscribe({
      next: (data: NamedResponse[]) => {
        this.shipmentBoxesList = data;
      },
      error: (error: Error) => {
        this.errorService.handleError(error);
      },
    });
  }

  async getPostingProfilesList(): Promise<void> {
    try {
      const data: PostingProfileResponse[] = await firstValueFrom(
        this.postingProfileService.getPostingProfiles(
          this.userDetails.companyId
        )
      );

      this.postingProfileList = data;
      this.filteredPostingProfiles = data;
    } catch (error) {
      this.errorService.handleError(error as Error);
    }
  }

  filterProfiles() {
    const filterValue = this.searchPostingProfileText.toLowerCase();
    this.filteredPostingProfiles = this.postingProfileList.filter((p) =>
      p.name.toLowerCase().includes(filterValue)
    );
  }

  setPostingProfile(postingProfileId: number) {
    this.createProductRequest.listerProduct.postingProfileId = postingProfileId;
    this.searchPostingProfileText = '';
    this.callPostingProfileHandlers();
  }
  async getProductAttributesByCategoryTypeId() {
    const categoryTypeId = this.categoriesList.find(
      (cat) => cat.id === this.createProductRequest.categoryId
    )?.productCategoryTypeId;
    if (!categoryTypeId) {
      return;
    }
    await this.productService
      .getProductAttributesByCategoryTypeId(categoryTypeId)
      .subscribe((result) => {
        this.productAttributes = result;
        this.productService
          .getProductCategoryTypeById(categoryTypeId)
          .subscribe((catType) => {
            this.categoryType = catType;
            if (catType.productCategoryTypeAttributes) {
              this.productAttributes = this.mapToSelectedAttributes(
                catType.productCategoryTypeAttributes,
                this.productAttributes
              );
            }
          });
        this.productAttributes.forEach((attr) => {
          this.selectedAttributes[attr.id] = null;
        });

        if (this.createProductRequest?.attributes?.length) {
          const attrsCopy = [...this.createProductRequest.attributes];
          for (const prodAttr of attrsCopy) {
            const matched = this.productAttributes.find(
              (pa) => pa.name?.toLowerCase() === prodAttr.name?.toLowerCase()
            );
            if (matched) {
              const listItem = matched.productAttributeListItems?.find(
                (li) => li.value === prodAttr.value
              );
              if (listItem) {
                this.selectedAttributes[matched.id] = listItem.id;
              } else {
                this.selectedAttributes[matched.id] = null;
              }
              const idx = this.createProductRequest.attributes.findIndex(
                (a) => a === prodAttr
              );
              if (idx > -1) this.createProductRequest.attributes.splice(idx, 1);
            }
          }
        }
      });
  }

  get visibleProductAttributes(): ProductAttributeModel[] {
    if (!this.createProductRequest?.attributes) return [];
    return this.createProductRequest.attributes.filter(
      (attr) => !this.productAttributes.some((pa) => pa.name === attr.name)
    );
  }
  mapToSelectedAttributes(
    selectedAttributes: ProductCategoryTypeAttribute[],
    allAttributes: ProductAttribute[]
  ): ProductAttribute[] {
    return allAttributes
      .filter((attr) =>
        selectedAttributes.some((sa) => sa.productAttributeId === attr.id)
      )
      .map((attr) => {
        const selectedAttr = selectedAttributes.find(
          (sa) => sa.productAttributeId === attr.id
        );

        return {
          ...attr,
          productCategoryTypeAttributeId: selectedAttr?.id ?? 0,
          isSelected: true,
          isMandatory: selectedAttr?.isMandatory ?? false,
        };
      });
  }

  onAttributeSelected(attributeId: number) {
    const selectedItemId = this.selectedAttributes[attributeId];
  }
  // ===============================================================Logical Code================================================================
  async incrementTabIndex() {
    if (this.tabIndex < 5) {
      this.tabIndex++;
      if (this.tabIndex == 3) {
        await this.getProductAttributesByCategoryTypeId();
        await this.getMarketplaceAttributes();
      }
    } else if (this.tabIndex === 5) {
      this.createUpdateProduct();
      this.tabIndex = 6;
      return;
    }
  }

  decrementTabIndex() {
    if (this.tabIndex > 1) {
      this.tabIndex--;
    }
  }

  formatPlaceHolders(placeHolder: string): string {
    if (!placeHolder) return '';

    let result = placeHolder.replace(/([a-z])([A-Z])/g, '$1 $2');
    result = result.replace(/\s+/g, ' ').trim();
    result = result.toLowerCase();

    return 'Enter ' + result + ' name';
  }

  // ===============================================================Action Code================================================================
  getCategoryName(categoryId: number | null): string {
    if (categoryId === null) return '-';
    const category = this.categoriesList?.find((cat) => cat.id === categoryId);
    return category ? category.name : '-';
  }

  getDepartmentName(departmentId: number | null): string {
    if (departmentId === null) return '-';
    const department = this.departmentsList?.find(
      (cat) => cat.id === departmentId
    );
    return department ? department.name : '-';
  }

  getBrandName(brandId: number | null): string {
    if (brandId === null) return '-';
    const brand = this.brandsList?.find((cat) => cat.id === brandId);
    return brand ? brand.name : '-';
  }

  getCarrierName(carrierId: number | null): string {
    if (carrierId === null) return '-';
    const carrier = this.carriersList?.find((cat) => cat.id === carrierId);
    return carrier ? carrier.name : '-';
  }

  getShipmentBoxName(boxId: number | null): string {
    if (boxId === null) return '-';
    const box = this.shipmentBoxesList?.find((cat) => cat.id === boxId);
    return box ? box.name : '-';
  }

  getSupplierName(supplierId: number | null): string {
    if (supplierId === null) return 'Donated Goods';
    const supplier = this.suppliersList?.find((cat) => cat.id === supplierId);
    return supplier ? supplier.name : 'Donated Goods';
  }

  getWarehouseLocationName(warehouseLocationId: number | null): string {
    if (warehouseLocationId === null) return '-';
    const warehouseLocation = this.warehouseLocationList?.find(
      (cat) => cat.id === warehouseLocationId
    );
    return warehouseLocation
      ? warehouseLocation.name
      : 'Select posting profile';
  }

  getPostingProfleName(postingProfileId: number | null): string {
    if (postingProfileId === null) return 'Select posting profile';
    const postingProfileName = this.postingProfileList?.find(
      (cat) => cat.id === postingProfileId
    );

    return postingProfileName
      ? postingProfileName.name
      : 'Select posting profile';
  }

  // ====================================================================Image Code================================================================
  browseProductImg() {
    if (this.browseProductImgEle) {
      this.browseProductImgEle.nativeElement.click();
    }
  }

  getProductImgUrl(event: any) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const selectedImgFile = input.files[0];

      const uploadedImages = this.createProductRequest.productImages.filter(
        (item) => item.url
      );

      if (uploadedImages.length >= 9) {
        this.toaster.error('You can only add a maximum of 9 images.');
        return;
      }
      // Create a new ProductImageModel for the selected image
      if (this.createProductRequest.productImages.length < this.maxImages) {
        const newImage = new ProductImageModel();
        this.createProductRequest.productImages.push(newImage);
      }
      const emptySlot = this.createProductRequest.productImages.find(
        (item) => !item.url
      );
      if (emptySlot) {
        emptySlot.imgFile = selectedImgFile;
        emptySlot.url = URL.createObjectURL(selectedImgFile);
      }
    }
  }

  manageProductImageAction(val: string, index: number) {
    if (val === 'delete') {
      if (this.createProductRequest.productImages[index].isPrimary) {
        this.toaster.error('Primary image cannot be deleted.');
        return;
      }
      if (this.createProductRequest.productImages[index].id > 0) {
        this.productImagesToDelete.push(
          this.createProductRequest.productImages[index]
        );
      }
      this.createProductRequest.productImages.splice(index, 1);
      this.createProductRequest.productImages.push(new ProductImageModel());
    } else if (val === 'primary') {
      this.createProductRequest.productImages.forEach((item) => {
        item.isPrimary = false;
      });
      this.createProductRequest.productImages[index].isPrimary = true;
    }
  }

  uploadAndMapNewImages(productId: number): Observable<boolean> {
    // Upload new images

    const validImages = this.productsImagesToReview.filter(
      (item) => item.id === 0 && item.imgFile != null
    );

    if (validImages.length === 0) {
      return of(false);
    }

    const uploadRequests = validImages.map((imgObj) =>
      this.productService.uploadImage(
        this.userDetails.companyId,
        productId,
        imgObj.imgFile
      )
    );
    return forkJoin(uploadRequests).pipe(
      switchMap((uploadedImages) => {
        const createImageRequests = uploadedImages.map(
          (uploadResult, index) => {
            return this.productService.mapProductImages(productId, {
              id: 0,
              productId: productId,
              blobFileId: uploadResult.blobFileId,
              isPrimary: validImages[index].isPrimary,
              url: '',
              imgFile: null,
            });
          }
        );

        return forkJoin(createImageRequests).pipe(map(() => true));
      })
    );
  }

  updateImage(): Observable<boolean> {
    // Find all images that already exist (id > 0) and have a file to update
    const imagesToUpdate = this.productsImagesToReview.filter(
      (item) => item.id > 0 && item.isPrimary
    );

    if (imagesToUpdate.length === 0) {
      return of(true);
    }

    // For each image, call the editProductImage API
    const updateRequests = imagesToUpdate.map((img) =>
      this.productService.editProductImage(img.productId, img)
    );

    return forkJoin(updateRequests).pipe(map(() => true));
  }

  // ========================================================================Attributes Code================================================================
  addAttribute() {
    const trimmedName = this.createAttributeName?.trim();
    if (trimmedName) {
      // Ensure attributes array is initialized
      if (!this.createProductRequest.attributes) {
        this.createProductRequest.attributes = [];
      }
      // Optional: Prevent duplicate attribute names
      const exists = this.createProductRequest.attributes.some(
        (attr) => attr.name.toLowerCase() === trimmedName.toLowerCase()
      );
      if (exists) {
        this.toaster.error('Attribute name already exists.');
      } else {
        const attributeObj = new ProductAttributeModel();
        attributeObj.name = trimmedName;
        this.createProductRequest.attributes.push(attributeObj);
      }
    } else {
      this.toaster.error('Please enter the attribute name first.');
    }
    this.createAttributeName = '';
  }

  removeAttribute(index: number) {
    if (index > -1 && this.createProductRequest.attributes.length > index) {
      this.createProductRequest.attributes.splice(index, 1);
    }
  }

  //=========================================================================Marketplace Attributes Code========================================================
  async getMarketplaceAttributes(): Promise<void> {
    let targetAttributes =
      this.createProductRequest.listerProduct.marketplaceAttributes;

    // Step 1: Build a Set of existing attribute names (to avoid duplicates)
    const existingNames = new Set(targetAttributes.map((attr) => attr.name));

    // Step 2: Loop through the rules and add only new attributes
    this.postingProfile.rules.forEach((rule) => {
      if (rule.marketplaceAttributes && rule.marketplaceAttributes.length > 0) {
        rule.marketplaceAttributes.forEach((attr) => {
          if (attr && attr.name && !existingNames.has(attr.name)) {
            targetAttributes.push({
              ...attr,
              values: Array.isArray(attr.values) ? attr.values : [],
            });
            existingNames.add(attr.name);
          }
        });
      }
    });

    // ✅ Step 3: Assign back the cleaned array
    this.createProductRequest.listerProduct.marketplaceAttributes =
      targetAttributes;
  }

  reInitializeMarketplaceAttributes() {
    this.createProductRequest.listerProduct.marketplaceAttributes = [];
  }

  callPostingProfileHandlers(): void {
    this.getSelectedPostingProfileAsync();
    this.reInitializeMarketplaceAttributes();
  }

  // ========================================================================Product Action Code================================================================
  async createUpdateProduct() {
    this.createProductRequest.listerProduct.supplyType =
      ProductSupplyType.DonatedGoods;
    this.isActionLoading = true;
    this.createProductRequest.companyId = Number(this.userDetails.companyId);
    this.createProductRequest.warehouseId = this.defaultWarehouseId;
    if (
      this.createProductRequest.listerProduct.listingStatus ===
      ProductListingStatus.NotListed
    ) {
      this.createProductRequest.listerProduct.listingStatus =
        this.createProductRequest.status === ProductStatus.Active
          ? ProductListingStatus.ReadyForListing
          : ProductListingStatus.NotListed;
    }

    this.productsImagesToReview = [
      ...this.createProductRequest.productImages,
    ].filter((item) => item.url != '');

    this.createProductRequest.internalStatus =
      this.productsImagesToReview.length == 0
        ? ProductInternalStatus.PendingImages
        : ProductInternalStatus.Completed;
    this.createProductRequest.productImages = [];
    const isUpdate = this.createProductRequest.id > 0;

    try {
      // Delete images
      if (isUpdate && this.productImagesToDelete.length > 0) {
        await Promise.all(
          this.productImagesToDelete.map((img) =>
            firstValueFrom(
              this.productService.deleteProductImage(img.productId, img.id)
            )
          )
        );
      }

      const rulesToDelete = this.postingProfileRuleMappingList.filter(
        (rule) =>
          rule.id > 0 &&
          !this.postingProfile.rules.some(
            (r) => r.id === rule.postingProfileRuleId
          )
      );
      this.createProductRequest.attributes = Object.entries(
        this.selectedAttributes
      )
        .filter(([_, valueId]) => valueId != null && valueId !== '')
        .map(([attributeId, valueId]) => {
          const attr = this.productAttributes.find(
            (a) => a.id === Number(attributeId)
          );
          const val = attr?.productAttributeListItems?.find(
            (v) => v.id === Number(valueId)
          );

          return {
            name: attr?.name || '',
            value: val?.value || '',
          };
        });

      // Save or update product
      const productServiceCall = isUpdate
        ? this.productService.editProduct(this.createProductRequest)
        : this.productService.createProduct(this.createProductRequest);

      const productObj = await firstValueFrom(productServiceCall);

      //update the existing image if it is marked as primary
      const primaryImageId =
        this.productsImagesToReview.find((img) => img.isPrimary)?.id || 0;
      if (primaryImageId > 0 && this.primaryImageId !== primaryImageId) {
        await firstValueFrom(this.updateImage());
      }
      // Upload new images and map them to the product
      await firstValueFrom(this.uploadAndMapNewImages(productObj.id));

      // --- CREATE/UPDATE POSTING PROFILE RULE MAPPINGS HERE ---
      await this.createUpdatePostingProfileRule(productObj.id);

      // Delete rule
      if (isUpdate && rulesToDelete.length > 0) {
        await Promise.all(
          rulesToDelete.map((rule) =>
            firstValueFrom(
              this.productService.deletePostingProfileMapping(rule.id)
            )
          )
        );
      }

      this.isActionLoading = false;
      this.createUpdateAction.isAdded = true;
      this.triggerParentMethod.emit();
    } catch (err) {
      this.isActionLoading = false;
      this.createUpdateAction.isAdded = false;
      this.createUpdateAction.actionStatusText = this.getErrorMessage(err);
    }
  }

  getErrorMessage(err: any): string {
    if (!err) return 'An unexpected error occurred.';

    if (err.status === 400 && err.error?.errors) {
      const validationMessages = err.error.errors
        .map((error: any) => `${error.field}: ${error.message}`)
        .join('\n');
      return validationMessages;
    } else {
      return err.error?.detail || 'An unexpected error occurred.';
    }
  }

  selectedSupplyType(event: Event) {
    const value = Number((event.target as HTMLSelectElement).value);
    if (
      this.createProductRequest.listerProduct.supplyType ==
      ProductSupplyType.DonatedGoods
    ) {
      this.createProductRequest.supplierId = null; // Reset supplier if supply type is Donated Goods
    }
  }

  async getProductByIdAsync(productId: number) {
    this.tabIndex = 1;
    this.scrollToTopTab1();
    this.postingProfile = new PostingProfileResponse();
    this.productImagesToDelete = [];
    this.productsImagesToReview = [];
    this.primaryImageId = 0;
    this.postingProfileRuleMappingList = [];
    await this.loadRequiredData();

    if (productId > 0) {
      this.isLoading = true;
      this.productService.getProductById(productId).subscribe({
        next: (response: IMSproductResponse) => {
          this.createProductRequest.productDepartmentId =
            response.productDepartmentId;
          this.getCategoriesListAsync();
          this.createProductRequest = response;
          this.getSelectedPostingProfileAsync();
          //assign imageId later use it for update
          this.primaryImageId =
            this.createProductRequest.productImages.find((img) => img.isPrimary)
              ?.id || 0;
          const imagesToAdd =
            9 - this.createProductRequest.productImages.length;
          for (let i = 1; i <= imagesToAdd; i++) {
            const imgObj = new ProductImageModel();
            this.createProductRequest.productImages.push(imgObj);
          }
          this.isLoading = false;
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.isLoading = false;
        },
      });
    } else {
      this.createProductRequest = new CreateIMSproductRequest();
      const warehouseLocationId = localStorage.getItem('warehouseLocationId');
      this.createProductRequest.warehouseLocationId =
        Number(warehouseLocationId) || null;

      for (let i = 1; i <= this.maxImages; i++) {
        let imgObj = new ProductImageModel();
        this.createProductRequest.productImages.push(imgObj);
      }
    }
  }

  validateProductActions(): boolean {
    switch (this.tabIndex) {
      case 1:
        return !!(
          (
            this.createProductRequest.name.trim() &&
            this.createProductRequest.listerProduct.condition > 0 &&
            this.createProductRequest.description.trim() &&
            this.createProductRequest.categoryId != null &&
            this.createProductRequest.brandId != null &&
            this.createProductRequest.manufacturer.trim() &&
            this.createProductRequest.warehouseLocationId != null &&
            this.createProductRequest.listerProduct.postingDescription.trim()
          )
          // this.createProductRequest.listerProduct.supplyType != null &&
          // (this.createProductRequest.listerProduct.supplyType ==
          //   this.productSupplyType.Supplier
          //   ? this.createProductRequest.supplierId != null &&
          //   this.createProductRequest.supplierId > 0
          //   : true)
        );

      case 2:
        return this.postingProfile.id > 0 && this.postingProfile.status == 2
          ? true
          : false;

      case 3:
        // Validate product-level attributes (those not represented by company defaults)
        let isAllAttrDone = true;
        const productLevelAttrs = this.visibleProductAttributes || [];
        if (productLevelAttrs.length) {
          isAllAttrDone = productLevelAttrs.every(
            (item) => item.value != null && String(item.value).trim() !== ''
          );
        }

        // Validate company-default attributes that are marked mandatory
        let areCompanyMandatoryAttrsDone = true;
        const mandatoryCompanyAttrs = (this.productAttributes || []).filter(
          (pa) => pa.isMandatory
        );
        if (mandatoryCompanyAttrs.length) {
          areCompanyMandatoryAttrsDone = mandatoryCompanyAttrs.every((pa) => {
            // If dropdown has a selection, consider it filled
            const sel = this.selectedAttributes[pa.id];
            if (sel != null && sel !== '') return true;

            // Otherwise, check if a product-level attribute with same name exists and has a value
            const prodAttr = (this.createProductRequest.attributes || []).find(
              (a) => a.name?.toLowerCase() === pa.name?.toLowerCase()
            );
            return (
              prodAttr && prodAttr.value && String(prodAttr.value).trim() !== ''
            );
          });
        }
        let isAllMarketplaceAttrDone;
        if (
          this.createProductRequest.listerProduct.marketplaceAttributes.length
        ) {
          isAllMarketplaceAttrDone =
            this.createProductRequest.listerProduct.marketplaceAttributes.every(
              (item) => item.value
            );
        }

        return !!(
          this.createProductRequest.height > 0 &&
          this.createProductRequest.width > 0 &&
          this.createProductRequest.length > 0 &&
          this.createProductRequest.dimensionUnit > 0 &&
          this.createProductRequest.weight > 0 &&
          this.createProductRequest.weightUnit > 0 &&
          (productLevelAttrs.length > 0 ? isAllAttrDone : true) &&
          (mandatoryCompanyAttrs.length > 0
            ? areCompanyMandatoryAttrsDone
            : true) &&
          (this.createProductRequest.listerProduct.marketplaceAttributes
            .length > 0
            ? isAllMarketplaceAttrDone
            : true)
        );

      case 4:
      case 5:
        return true;

      default:
        return false;
    }
  }

  // ========================================================================Posting Profile Code================================================================
  async createUpdatePostingProfileRule(productId: number) {
    this.isActionLoading = true;
    if (this.postingProfile.rules.length > 0) {
      this.postingProfile.rules.forEach((item) => {
        const rule = this.postingProfileRuleMappingList.find(
          (x) => x.postingProfileRuleId === item.id
        );
        if (rule) {
          rule.bidIncrement = item.bidIncrement;
          rule.buyNowPrice = item.buyNowPrice;
          rule.reservePrice = item.reservePrice;
          rule.startingBid = item.startingBid;
          rule.salesFloorPrice = this.postingProfile.salesFloorPrice || 0;
          rule.handlingCharges = this.postingProfile.handlingCharges || 0;
        } else {
          const newRule = new ProductPostingProfileRuleMappingModel();
          newRule.bidIncrement = item.bidIncrement;
          newRule.buyNowPrice = item.buyNowPrice;
          newRule.reservePrice = item.reservePrice;
          newRule.startingBid = item.startingBid;
          newRule.salesFloorPrice = this.postingProfile.salesFloorPrice || 0;
          newRule.handlingCharges = this.postingProfile.handlingCharges || 0;
          newRule.postingProfileRuleId = item.id;
          newRule.productId = this.createProductRequest.id;
          this.postingProfileRuleMappingList.push(newRule);
        }
      });
    }
    const updateOrCreate$ = this.postingProfileRuleMappingList.map((item) => {
      item.productId = productId;
      if (item.id > 0) {
        return this.productService.editPostingProfileMapping(item);
      } else {
        return this.productService.createPostingProfileMapping(item);
      }
    });
    try {
      if (updateOrCreate$.length > 0) {
        await Promise.all(updateOrCreate$.map((obs) => firstValueFrom(obs)));
      }
      this.isActionLoading = false;
    } catch (error) {
      this.isActionLoading = false;
      this.errorService.handleError(error);
    }
  }

  async getSelectedPostingProfileAsync() {
    if (this.createProductRequest.listerProduct.postingProfileId != null) {
      this.postingProfile =
        this.postingProfileList.find(
          (postingProfile) =>
            postingProfile.id ===
            this.createProductRequest.listerProduct.postingProfileId
        ) || new PostingProfileResponse();

      this.postingProfile.statusName =
        this.postingProfile.status > 0
          ? this.postingProfileEnumList.find(
              (item) => item.id === this.postingProfile.status
            )?.name || '-'
          : '-';
      this.postingProfile.auctionPaymentDueOptionName =
        this.postingProfile.auctionPaymentDueOption > 0
          ? this.auctionStartOptionEnumList.find(
              (item) => item.id === this.postingProfile.auctionPaymentDueOption
            )?.name || '-'
          : '-';

      this.postingProfile.endOfAuctionActionName =
        this.postingProfile.endOfAuctionAction > 0
          ? this.endOfAuctionActionEnumList.find(
              (item) => item.id === this.postingProfile.endOfAuctionAction
            )?.name || '-'
          : '-';

      for (let ruleItem of this.postingProfile.rules) {
        ruleItem.typeName =
          ruleItem.type > 0
            ? this.postingProfileRuleTypeEnumList.find(
                (item) => item.id === ruleItem.type
              )?.name || '-'
            : '-';
        ruleItem.marketplaceName =
          ruleItem.marketplace > 0
            ? this.marketplaceEnumList.find(
                (item) => item.id === ruleItem.marketplace
              )?.name || '-'
            : '-';
        ruleItem.auctionStartOptionName =
          ruleItem.auctionStartOption > 0
            ? this.auctionStartOptionEnumList.find(
                (item) => item.id === ruleItem.auctionStartOption
              )?.name || '-'
            : '-';
        if (ruleItem.marketplaceAccount == null) {
          ruleItem.marketplaceAccount = new MarketplaceAccountLiteResponse();
        }
      }
      try {
        this.postingProfileRuleMappingList = await firstValueFrom(
          this.productService.getPostingProfileMappings(
            this.createProductRequest.id
          )
        );
        if (this.postingProfileRuleMappingList.length > 0) {
          this.postingProfile.rules.forEach((item) => {
            const mapping = this.postingProfileRuleMappingList.find(
              (x) => x.postingProfileRuleId === item.id
            );
            if (mapping) {
              item.buyNowPrice = mapping.buyNowPrice;
              item.reservePrice = mapping.reservePrice;
              item.startingBid = mapping.startingBid;
              item.bidIncrement = mapping.bidIncrement;
              // item.salesFloorPrice = mapping.salesFloorPrice;
              // item.handlingCharges = mapping.handlingCharges;
            }
          });
        }
      } catch (error) {
        // this.errorService.handleError(error);
        console.log('Error fetching posting profile mappings:', error);
      }
    }
  }
  allowDecimal(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const key = event.key; // <-- modern way

    // Allow navigation keys
    if (
      ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(key)
    ) {
      return;
    }

    // Allow only digits and dot
    if (!/^[0-9.]$/.test(key)) {
      event.preventDefault();
    }

    // Prevent multiple dots
    if (key === '.' && input.value.includes('.')) {
      event.preventDefault();
    }
  }
}
